import { useMutation, useQueryClient } from '@tanstack/react-query'

import { initFilesSdk } from '../filesSdk'

type RenameItemParams = {
  id: number
  name: string
}

export const useRenameItemMutation = () => {
  const { filesSdk, success } = initFilesSdk()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, name }: RenameItemParams) => {
      if (!success) {
        return
      }

      if (!filesSdk) return

      await filesSdk.items.rename({ id, name })
      await queryClient.invalidateQueries({ queryKey: ['files-list'] })
      return
    }
  })
}
